import styled from 'styled-components';
import { ModalFooter, Row } from 'react-bootstrap';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';

export const CustomTemplateAddEditModalFooterStyled = styled(ModalFooter)`
  & > .btn-danger {
    float: left;
  }
`;

export const InfoRowStyled = styled(Row)`
  margin-top: -12px;
  color: lightgray;
`;

export const AutoTranslatedRowStyled = styled(Row)`
  margin-bottom: 15px;
`;

export const StyledCheckboxField = styled(CheckboxField)`
  padding-left: 14px;
`;
